
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { OrderDetailService } from './service/order-detail.service';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, finalize, Observable, Subject, takeUntil } from 'rxjs';
import { MapTrackingComponent } from './components/map-tracking/map-tracking.component';
import { LoadImagesService } from '../../../core/service/load-image.service';
import { MapTrrackingService } from './components/map-tracking/service/map-tracking.service';
import { coordenadasDestino, coordenadasOrigen, Infopayment, OrderDetailResponse, Product } from './interfaces/detail-order.interface';
import { ArrowBackComponent } from "../../../shared/components/arrow-back/arrow-back.component";
import { ChatCliRepComponent } from "./components/chat-cli-rep/chat-cli-rep.component";
import { StepperComponent } from "./components/stepper/stepper.component";
import { ListProductsOrderComponent } from "./components/list-products-order/list-products-order.component";
import { ListProductsOrderService } from './components/list-products-order/service/list-products-order.service';
import { InfoPaymentComponent } from "./components/info-payment/info-payment.component";
import { MapNewTrackingService } from './components/map-tracking/service/map-new-tracking.service';
import { SocketService } from '../../../core/service/socket/socket.service';
import { ModalViewRateComponent } from "./components/modal-view-rate/modal-view-rate.component";
import { OrdenCanceledComponent } from "./components/orden-canceled/orden-canceled.component";
import { FirebaseMessagingService } from '../../../core/service/firebase-messaging.service';
import { RequestClaimComponent } from "./components/request-claim/request-claim.component";
import { ReclaimOrderComponent } from "./components/reclaim-order-component/reclaim-order.component";
import { CodeVerificationComponent } from "./components/code-verification/code-verification.component";
import { ConfettiService } from '../../../shared/confetti/confetti.component';
import { TimerComponent } from "../../../shared/components/timer/timer.component";
import { FacturarComponent } from "./components/facturar/facturar.component";

@Component({
  selector: 'orders-user-detail-order',
  standalone: true,
  imports: [MapTrackingComponent, ArrowBackComponent, ChatCliRepComponent, StepperComponent, ListProductsOrderComponent, InfoPaymentComponent, ModalViewRateComponent, OrdenCanceledComponent, RequestClaimComponent, ReclaimOrderComponent, CodeVerificationComponent, TimerComponent, FacturarComponent],
  templateUrl: './detail-order.component.html',
  styleUrl: './detail-order.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailOrderComponent implements OnInit, OnDestroy {
  orderId!: number;
  imageURl: string = '';
  showTimer = signal<boolean>(false);
  private destroy$ = new Subject<void>();
  picture_delivery: string = '';
  reasonCancel: string = '';
  orderDetailSubject = new BehaviorSubject<OrderDetailResponse>({
    status: false,
    message: '',
    data: {
      ordersData: [],
      products: []
    }
  });
  showMap = signal<boolean>(false);
  listProducts = signal<Product[]>([]);
  currentStatus = signal<number>(3); // Status inicial por defecto
  paymentMethod: string = '';
  infoPayment: Infopayment = {
    payment: '', // Método de pago utilizado
    costo_envio: 0, // Costo del envío
    totalOrden: 0, // Total de la orden
    baksheesh: 0, // Propina del repartidor
    baseRate: 0,
    serviceRate: 0,
    creditAmount: 0,
    cardAmount: 0,
    cashAmount: 0
  };
  orderNumber: string = '';
  orderDetail = this.orderDetailSubject.asObservable();
  coordenadasOrigen: coordenadasOrigen = {
    lat: 0,
    lng: 0
  };
  coordenadasDestino: coordenadasDestino = {
    lat: 0,
    lng: 0
  }

  showChat = signal<boolean>(false);
  @ViewChild(ModalViewRateComponent) modalViewRateComponent!: ModalViewRateComponent;
  @ViewChild(FacturarComponent) facturarModal!: FacturarComponent;

  comments = {
    isCommentDelivery: false,
    isCommentEstablishment: false,
    shoppingCart: ''
  }
  confettiService = inject(ConfettiService);

  hasIssue = signal<boolean>(false);
  isLoading = signal<boolean>(false);
  loadStatusReclaim = signal<boolean>(false);
  constructor(private orderDetailService: OrderDetailService,
    private route: ActivatedRoute,
    private loadImagesService: LoadImagesService,
    public mapTrackingService: MapTrrackingService,
    private cdr: ChangeDetectorRef,

    private listProductsOrderService: ListProductsOrderService,
    private mapNewTrackingService: MapNewTrackingService,
    private socketService: SocketService,
    private firebaseMessagingService: FirebaseMessagingService
  ) {
    this.imageURl = this.loadImagesService.linkImage;
    effect(() => {
      if (this.currentStatus() === 24 || this.currentStatus() === 3 || this.currentStatus() === 39 || this.currentStatus() === 28) {
        this.showMap.set(false);
      }
      if (this.orderId) {
        this.mapNewTrackingService.joinRoom(this.orderId);
      }
      this.socketService.on('rep_asing', (data) => {
        this.loadOrder();
        this.showChat.set(true);
      })
      this.socketService.on('roomLeft', (data) => {
        this.loadOrder();
        this.showChat.set(false);
        this.showMap.set(false);
      })
    })
    this.socketService
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.orderId = params['id'];
      // Suscribirse a cambios de estado del socket
      this.loadOrder();

    });

    this.notificationsFirebase();



  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Método para convertir códigos de payment a nombres legibles
  private convertPaymentMethod(code: string): string {
    const paymentMethods: { [key: string]: string } = {
      'MKP-Créditos': 'Tarjeta-Créditos',
      'Marketplace': 'Tarjeta',
      'MKP': 'Tarjeta',
    };

    return paymentMethods[code] || code;
  }

  loadOrder(): void {
    // Inicializar estado de carga
    this.listProductsOrderService.setLoading(true);
    this.isLoading.set(true);

    this.orderDetailService.getOrderDetails(this.orderId).pipe(
      finalize(() => {
        this.isLoading.set(false);
        this.cdr.markForCheck();
      })
    ).subscribe({
      next: (response: OrderDetailResponse) => {
        this.orderDetailSubject.next(response);
        // console.log('respuesta ', response);

        this.infoPayment = {
          payment: this.convertPaymentMethod(response.data.ordersData[0].payment), // Conversión aplicada / Método de pago utilizado
          costo_envio: response.data.ordersData[0].costo_envio,     // Costo del envío
          totalOrden: response.data.ordersData[0].totalOrden,      // Total de la orden
          baksheesh: response.data.ordersData[0].baksheesh,        // Propina del repartidor
          baseRate: response.data.ordersData[0].baseRate,
          serviceRate: response.data.ordersData[0].serviceRate,
          creditAmount: response.data.ordersData[0].creditAmount,
          cardAmount: response.data.ordersData[0].cardAmount,
          cashAmount: response.data.ordersData[0].cashAmount

        }
        this.reasonCancel = response.data.ordersData[0].reason_cancel;
        this.orderNumber = response.data.ordersData[0].no_order;
        // Inicializar el status actual con el status de la orden
        this.currentStatus.set(response.data.ordersData[0].id_status);
        this.initializeOrderMap(response);
        this.listProductsOrderService.setListProducts(response.data.products);
        this.hasIssue.set(response.data.ordersData[0].hasIssue);
        this.loadStatusReclaim.set(true);

        this.comments = {
          isCommentDelivery: response.data.ordersData[0].isCommentDelivery,
          isCommentEstablishment: response.data.ordersData[0].isCommentEst,
          shoppingCart: response.data.ordersData[0].PK_shoppingCart_id
        }

        this.picture_delivery = response.data.ordersData[0].picture_delivery;



        if (this.currentStatus() === 24) {
          this.confettiService.fromSides();
        }
        if (this.currentStatus() === 25) {
          // console.log('hola estoy aqui adentro', this.currentStatus());

          this.showTimer.set(true);
        } else {
          this.showTimer.set(false);
        }



        this.cdr.markForCheck(); // Forzar detección de cambios después de asignar paymentMethod

      },
      error: (error) => {
        console.error('Error:', error);
        this.listProductsOrderService.setLoading(false);
      }
    });
  }

  initializeOrderMap(orderDetail: OrderDetailResponse): void {

    // Verificar que orderDetail.data.ordersData existe y tiene elementos
    if (orderDetail.data && orderDetail.data.ordersData && orderDetail.data.ordersData.length > 0) {
      const firstItem = orderDetail.data.ordersData[0];

      if (firstItem.id_status !== 24
        && firstItem.id_status !== 21
        && firstItem.id_status !== 39
        && firstItem.id_status !== 3
        && firstItem.id_status !== 28
      ) {
        // console.log('Inicializando mapa con:', orderDetail);
        this.showMap.set(true);
        // console.log('Iniciando tracking para order:', this.orderId);
        this.orderId = Number(this.orderId);
        this.coordenadasDestino = {
          lat: Number(firstItem.client_latitude),
          lng: Number(firstItem.client_longitude)
        };
        this.coordenadasOrigen = {
          lat: Number(firstItem.establishment_latitude),
          lng: Number(firstItem.establishment_longitude)
        };
        this.mapTrackingService.startTrackingOrder(this.orderId);
      } else {
        this.showMap.set(false);
        // console.log('id_status no válido:', firstItem.id_status);
      }
    }

  }

  // Método para manejar el cambio de status desde map-tracking
  onStatusChange(newStatus: number): void {
    // console.log('DetailOrderComponent - Status changed from', this.currentStatus(), 'to:', newStatus);
    this.currentStatus.set(newStatus);
    // console.log('DetailOrderComponent - currentStatus signal updated to:', this.currentStatus());
    this.cdr.markForCheck();
  }

  // En el template, usa orderDetail$ con async pipe
  getOrderDetail(): Observable<OrderDetailResponse> {
    return this.orderDetail;
  }


  notificationsFirebase(): void {
    // Suscribirse a notificaciones de cancelación de orden
    this.firebaseMessagingService.getOrderCancelledNotifications()
      .pipe(takeUntil(this.destroy$))
      .subscribe((notification) => {
        this.loadOrder();
      });

    // Suscribirse a notificaciones de cambio de estado de reclamo
    this.firebaseMessagingService.getStatusReclaimNotifications()
      .pipe(takeUntil(this.destroy$))
      .subscribe((notification) => {
        this.loadOrder();
      });

    // Suscribirse a notificaciones de reasignación de orden
    this.firebaseMessagingService.getReassignNotifications()
      .pipe(takeUntil(this.destroy$))
      .subscribe((notification) => {
        this.loadOrder();
      });
  }
  reclaimOrder() {
    this.loadOrder();
  }

  openModal() {
    this.facturarModal.openModal();
  }
}
